import "slick-slider";

export default function newsCarouselInit() {
    // Index sport-specific booster clubs carousel
    $("#news-carousel").slick({
        arrows: true,
        autoplay: true,
        dots: true,
        draggable: true,
        swipe: true,
        pauseOnHover: true,
        cssEase: "ease",
        accessibility: true,
        autoplaySpeed: 7000,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 2200,
                settings: {
                    arrows: true,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 1441,
                settings: {
                    arrows: true,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 1200,
                settings: {
                    arrows: true,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    $(function () {
        $('a[href*="#news-anchor"]:not([href="#"])').click(function () {
            if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
                if (target.length) {
                    $("html, body").animate(
                        {
                            scrollTop: target.offset().top - 100,
                        },
                        300
                    );
                    return false;
                }
            }
        });
    });
}
